import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
  catInfo: [],
  service: [],
  jobs: [],
  banner: [],
  relatedProds: [],
  relatedServices: [],
  gallery: [],
  page: [],
  team: [],
  testimonial: [],
  sitesetting: [],
};

const commonSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload;
    },
    setGallery: (state, action) => {
      state.gallery = action.payload;
    },
    setCurrentCategoryData: (state, action) => {
      state.catInfo = action.payload;
    },
    setRelatedProducts: (state, action) => {
      state.relatedProds = action.payload;
    },
    setService: (state, action) => {
      state.service = action.payload;
    },
    setBanner: (state, action) => {
      state.banner = action.payload;
    },
    setRelatedServices: (state, action) => {
      state.relatedServices = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setJobs: (state, action) => {
      state.jobs = action.payload;
    },
    setTeam: (state, action) => {
      state.team = action.payload;
    },
    setTestimonial: (state, action) => {
      state.testimonial = action.payload;
    },
    setsiteSetting: (state, action) => {
      state.sitesetting = action.payload;
    },
  },
});

export const {
  setProducts,
  setServices,
  setGallery,
  setBanner,
  setCurrentCategoryData,
  setRelatedProducts,
  setRelatedServices,
  setPage,
  setService,
  setJobs,
  setTeam,
  setTestimonial,
  setsiteSetting,
} = commonSlice.actions;

export default commonSlice.reducer;
